class PlannerCourseSelectionController {

    constructor() {
        this.view = new CourseListSelectionView({model: plannerApplication.data.courses});
        this.view.render();

        this.sectionNode = $('.section-courses');
        this.btnNext = this.sectionNode.find('.btn-next');
        this.selectionInputs = this.sectionNode.find('.btn-check');

        this.selectionInputs.attr('checked', false);
        this.btnNext.enableNextBtnIf(false);

        if (plannerApplication.yourProfile.getCourseName() != null) {
            let thisObj = this;
            _.each(this.selectionInputs, function (selectionInput) {
                selectionInput = $(selectionInput);
                let courseIdentifier = selectionInput.val();
                let course = plannerApplication.data.courseForIdentifier(courseIdentifier);

                if (course != null && course.getName() === plannerApplication.yourProfile.getCourseName()) {
                    selectionInput.attr('checked', true);
                    thisObj.btnNext.enableNextBtnIf(true);
                    thisObj.onCourseSelected();
                }
            });
        }
        this.selectionInputs.change(this.onUpdated.bind(this));
    }


    onUpdated(e) {
        e = nullIfUndefined(e);
        if (e != null) {
            let input = $(e.target);
            let courseIdentifier = input.val();
            let course = plannerApplication.data.courseForIdentifier(courseIdentifier);
            plannerApplication.yourProfile.setCourseModel(course);
            this.onCourseSelected();
            plannerApplication.userDataUpdated();
            plannerApplication.courseSelectionChanged();
            return;
        }

        this.btnNext.enableNextBtnIf(false);
    }


    onCourseSelected() {
        let course = plannerApplication.yourProfile.getSelectedCourse();
        this.btnNext.enableNextBtnIf(true);
        $('.app-course-title').html(course.getName());
        if(course.getElectivesTermName() !== null) {
            $('.app-course-electives-term').text(course.getElectivesTermName());
        } else {
            $('.app-course-electives-term').text(appTerms.Electives);
        }
        $('.app-course-information').attr('href', course.getLink());
        let showMe = $('.select-course-' + course.getIdentifier());
        let hideMe = $('.selection-course-dependent');
        showMeHideMe(showMe, hideMe);
    }

    updateGroupSelection(courseGroup) {
        _.each(this.selectionInputs, function (selectionInput) {
            selectionInput = $(selectionInput);
            let parent = selectionInput.parent();
            let courseIdentifier = selectionInput.val();
            let course = plannerApplication.data.courseForIdentifier(courseIdentifier);
            parent.showIf(course.getGroupName() === courseGroup.getName());
        });
    }
}
